/**
 * React Query keys for the recipient / alarm-dismiss emergency command center (anonymous magic link).
 */
export const recipientCommandCenterQueryKeys = {
  adminContacts: (dayOfEmergencyId: string, token: string) =>
    [...recipientCommandCenterQueryKeys.root, "admin-contacts", dayOfEmergencyId, token] as const,
  bubbleContext: (dayOfEmergencyId: string, token: string) =>
    [...recipientCommandCenterQueryKeys.root, "bubble-context", dayOfEmergencyId, token] as const,
  day: (dayOfEmergencyId: string, token: string) =>
    [...recipientCommandCenterQueryKeys.root, "day", dayOfEmergencyId, token] as const,
  declarations: (dayOfEmergencyId: string, token: string) =>
    [...recipientCommandCenterQueryKeys.root, "declarations", dayOfEmergencyId, token] as const,
  participants: (dayOfEmergencyId: string, token: string) =>
    [...recipientCommandCenterQueryKeys.root, "participants", dayOfEmergencyId, token] as const,
  root: ["recipient-command-center"] as const,
  timeline: (dayOfEmergencyId: string, token: string) =>
    [...recipientCommandCenterQueryKeys.root, "timeline", dayOfEmergencyId, token] as const,
  validate: (dayOfEmergencyId: string, token: string) =>
    [...recipientCommandCenterQueryKeys.root, "validate", dayOfEmergencyId, token] as const,
};
